import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Configuration } from './../../../config/configuration';

@Component({
  selector: 'sigv-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent implements OnInit {
  constructor(private router: Router, private configuration: Configuration) {}

  ngOnInit(): void {}

  goHome(): void {
    this.router.navigate([this.configuration.routePath.index]);
  }
}
